import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { UserData } from '../../providers/user';
import { EventProfilePage } from '../event-profile/event-profile';
import { Translate } from '../../providers/translate';

@Component({
  selector: 'page-event-stand-calendar',
  templateUrl: 'event-stand-calendar.html',
  providers:[EventData, AuthData,UserData]
})
export class EventStandCalendarPage {
  @ViewChild("schedule") schedule:any;
  hours=["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","23"]
  event:any;
  client:any;
  user:any;
  eventSource;
  viewTitle;
  lockSwipeToPrev:boolean = false;
  showCase:any;
  textTranslate:any;
  showCalendar:Boolean=false;

  tempData:any;

  isToday:boolean;
  calendar = {
      mode: 'day',
      currentDate: new Date(),
      dateFormatter: {
          formatMonthViewDay: function(date:Date) {
              return date.getDate().toString();
          },
          formatMonthViewDayHeader: function(date:Date) {
              return 'MonMH';
          },
          formatMonthViewTitle: function(date:Date) {
              return 'testMT';
          },
          formatWeekViewDayHeader: function(date:Date) {
              return 'MonWH';
          },
          formatWeekViewTitle: function(date:Date) {
              return 'testWT';
          },
          formatWeekViewHourColumn: function(date:Date) {
              return 'testWH';
          },
          formatDayViewHourColumn: function(date:Date) {
              return 'testDH';
          },
          formatDayViewTitle: function(date:Date) {
              return 'testDT';
          }
      }
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public eventData: EventData, public auth:AuthData, public userProvider:UserData, public toastCtrl:ToastController, translate: Translate, public loadingController:LoadingController, public alertController:AlertController) {
    this.event = this.navParams.get('event');
    this.client = this.navParams.get('client');
    this.showCase = this.navParams.get('data');
    this.user = this.navParams.get('user');
    translate.translateGroup(['Este stand ya tiene una reserva para esa hora'])
    .then(result => {
      this.textTranslate = result;
    });
    var showcase = this.event.showcaseCalendar;
    var hoy = new Date();
    var stringdate = hoy.getFullYear()+"-"+((hoy.getMonth().toString().length == 1)?"0"+(hoy.getMonth()+1):(hoy.getMonth()+1))+"-"+((hoy.getDate().toString().length == 1)?"0"+hoy.getDate():hoy.getDate());
    this.tempData = showcase.filter(x => x.date == stringdate)[0];
    if(this.tempData != undefined){
        this.tempData.dateFormat = new Date(this.tempData.date.split("-")[0],parseInt(this.tempData.date.split("-")[1])-1, this.tempData.date.split("-")[2]);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventStandCalendarPage');
    if(this.tempData != undefined && this.tempData != null){
        this.loadEvents();
    }else{
        this.HideLoading();
    }
    setTimeout(() => {
        if(this.tempData != undefined){
            var trs:any = document.querySelector(".swiper-slide-active .dayview-normal-event-container .dayview-normal-event-table tbody")
            this.hideHours(trs.children);
        }
    }, 1000);
  }

  private loading;
    private ShowLoading = (Text) =>{
       this.loading = this.loadingController.create({
            content: Text
        });

        this.loading.present();

        setTimeout(() => {
            
        }, 5000);
    }
    
    private HideLoading = () =>{
       this.loading.dismiss();
    }

	private toast;
	private ShowToast = (Message, duration, position)=>{
		this.toast = this.toastCtrl.create({
          message: Message,
          duration: duration,
          position: position
        });
        this.toast.present();
	}

    private Alert;
    private ShowConfirm = (Title, Message, handlerSi, handlerNo)=>{
		this.Alert = this.alertController.create({
			title: Title,
			subTitle: Message,
			buttons: [
				{
					text: 'Sí',
					handler: handlerSi
				},
        {
					text: 'No',
					handler: handlerNo
				}
			]
		});

  		this.Alert.present();
	}

  loadEvents() {
      this.ShowLoading("Cargando Reservas");
      this.eventData.getShowcaseReserve(this.client, this.event.id,this.showCase.id).subscribe((data: any) => {
        this.eventSource = this.createEvents(data);
      });
  }

  onViewTitleChanged(title) {
      this.viewTitle = title;
  }

  onEventSelected(event) {
      console.log('Event selected:' + event.startTime + '-' + event.endTime + ',' + event.title);
  }

  changeMode(mode) {
      this.calendar.mode = mode;
  }

  today() {
      this.calendar.currentDate = new Date();
  }

  onTimeSelected(ev) {
    console.log('Selected time: ' + ev.selectedTime + ', hasEvents: ' + (ev.events !== undefined && ev.events.length !== 0) + ', disabled: ' + ev.disabled);

    if((ev.events === undefined || ev.events.length === 0)){
        this.ShowConfirm("Seleccionar Reserva","¿Estas seguro de reservar a esta hora?",()=>{
            var startHour = ((ev.selectedTime.getHours().toString().length == 1)?"0"+ev.selectedTime.getHours():ev.selectedTime.getHours())+":"+((ev.selectedTime.getMinutes().toString().length == 1)?"0"+ev.selectedTime.getMinutes():ev.selectedTime.getMinutes());
            console.log(startHour);
            ev.selectedTime.setMinutes(this.tempData.range);
            var endHour = ((ev.selectedTime.getHours().toString().length == 1)?"0"+ev.selectedTime.getHours():ev.selectedTime.getHours())+":"+((ev.selectedTime.getMinutes().toString().length == 1)?"0"+ev.selectedTime.getMinutes():ev.selectedTime.getMinutes());
            console.log(endHour);
            console.log("Date: ",ev.selectedTime.getFullYear()+"-"+((ev.selectedTime.getMonth().toString().length == 1)?"0"+(ev.selectedTime.getMonth()+1):(ev.selectedTime.getMonth()+1))+"-"+((ev.selectedTime.getDate().toString().length == 1)?"0"+ev.selectedTime.getDate():ev.selectedTime.getDate()));

            if (!this.auth.getUser().isAnonymous) {
            this.userProvider.getProfile(this.client, this.auth.getUser())
            .then((user:any) => {
                this.ShowLoading("Reservando ...");
                setTimeout(() => {
                    this.user = user;
                    delete(this.user.$key)
                    delete(this.user.$exist)
                    delete(this.showCase.$key)
                    delete(this.showCase.$exists)
                    var dataSend = {
                        "ShowCaseInfo":this.showCase,
                        "UserInfo" : this.user,
                        "Date": ev.selectedTime.getFullYear()+"-"+((ev.selectedTime.getMonth().toString().length == 1)?"0"+(ev.selectedTime.getMonth()+1):(ev.selectedTime.getMonth()+1))+"-"+((ev.selectedTime.getDate().toString().length == 1)?"0"+ev.selectedTime.getDate():ev.selectedTime.getDate()),
                        "startHour":startHour,
                        "endHour":endHour
                    }
                    

                    this.eventData.setShowcaseReserve(this.client, this.event.id,this.showCase.id, this.user.id, dataSend);
                    this.ShowToast("Reserva generada para la hora de " + startHour + " a "+ endHour, 3000, 'top');
                }, 300);
            })
            .catch(() => {
                this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
            });
            } else {
            this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
            }
        },null)
    }
    else{
        this.ShowToast(this.textTranslate["Este stand ya tiene una reserva para esa hora"],5000,'top');
    }
      
  }

  onCurrentDateChanged(event:Date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      event.setHours(0, 0, 0, 0);
      this.isToday = today.getTime() === event.getTime();
  }

  createEvents(Events) {
      var events = [];
      this.user;
      for (var i = 0; i < Events.length; i += 1) {
            var date = this.tempData.dateFormat;
            var startTime;
            var endTime;
            startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(Events[i].startHour.split(":")[0]), parseInt(Events[i].startHour.split(":")[1]));
            endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(Events[i].endHour.split(":")[0]), parseInt(Events[i].endHour.split(":")[1]));
            var title = (this.user == undefined || this.user == null)?"Ocupado":(this.user.id == Events[i].UserInfo.id)?"Mi Reserva":"Ocupado"
            events.push({
                title: title,
                startTime: startTime,
                endTime: endTime,
                allDay: false
            });
          
      }

      if(this.showCalendar){
        this.HideLoading();
      }

      return events;
  }

  onRangeChanged(ev) {
      console.log('range changed: startTime: ' + ev.startTime + ', endTime: ' + ev.endTime);
  }

  markDisabled = (date:Date) => {
      var hourIni = this.tempData.hourIni.split(":")[0];
      var minuteIni = this.tempData.hourIni.split(":")[1];
      var currentIni = new Date( this.tempData.dateFormat.getFullYear(), this.tempData.dateFormat.getMonth(),  this.tempData.dateFormat.getDate(),parseInt(hourIni),parseInt(minuteIni));

      var hourEnd = this.tempData.hourEnd.split(":")[0];
      var minuteEnd = this.tempData.hourEnd.split(":")[1];
      var currentEnd = new Date( this.tempData.dateFormat.getFullYear(), this.tempData.dateFormat.getMonth(),  this.tempData.dateFormat.getDate(),parseInt(hourEnd),parseInt(minuteEnd));

      return date < currentIni || date > currentEnd;
  };

  hideHours(trs){
    var hourIni = this.tempData.hourIni.split(":")[0];
    var indexHourIni = this.hours.indexOf(hourIni);
    
    var hourEnd = this.tempData.hourEnd.split(":")[0];
    var indexHourEnd = this.hours.indexOf(hourEnd);
    

    for(var i = 0; i < indexHourIni;i++){
      trs[i].setAttribute("style","display:none");
    }

    for(var i = (indexHourEnd + 1); i < trs.length;i++){
      trs[i].setAttribute("style","display:none");
    }

    this.showCalendar = true;
    this.HideLoading();
  }

}



// WEBPACK FOOTER //
// ./src/pages/event-stand-calendar/event-stand-calendar.ts